import { Scene, type FullCalendarEvent, type Lightshow } from "luxedo-data"
import { ShowOverviewController } from "./ShowOverviewController"

export async function openShowOverview(scene: Scene | Lightshow, event?: FullCalendarEvent) {
	ShowOverviewController.open(scene, event)
}
